import { useEffect } from "react";
import { useMigrationState } from "@hooks/useMigrationState";
import {
  SignatureMigrationBanner,
  msUntilDeadlineCheck,
  signatureMigrationBanner,
} from "./SignatureMigrationAlert";

/**
 * The banner for the requests list. A failed request shows none, even when an
 * earlier answer is still cached. While the page stays open, the state is
 * asked for again when the deadline passes, so the banner changes with it.
 */
export function useSignatureMigrationBanner(): SignatureMigrationBanner | null {
  const { data, isError, dataUpdatedAt, refetch } = useMigrationState();

  // dataUpdatedAt: an answer equal to the last one still schedules again.
  useEffect(() => {
    const wait = msUntilDeadlineCheck(data);
    if (wait === null) return;
    const timer = setTimeout(() => {
      refetch();
    }, wait);
    return () => clearTimeout(timer);
  }, [data, dataUpdatedAt, refetch]);

  return isError ? null : signatureMigrationBanner(data);
}
